module.exports = __webpack_public_path__ + "img/export-hei.91af547c.svg";